// React Imports
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import PaginationComponent from "../../../../components/_utils/PaginationComponent";

// Redux Imports
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

// Component Imports
import ApprovalTopNavComponent from "../../../../components/_utils/CommonTopNav/ApprovalTopNav";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import Loader from "../../../../components/Loader/Index";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard";

// Details Popups
import FieldForceAccountDetailsPopup from "../../../../components/_utils/FieldForceAccountDetailsPopup";

// Utils Imports
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

import FieldForceTxnDetailsPopup from "../../../../components/FieldForceTransactionComp/FieldForceTxnDetailsPopup";
import ICONS from "../../../../assets/Icons";
import {
  fieldForceTxnActionable,
  resetFieldForceMultiApprovalError,
  resetFieldForceMultiDeniedApprovalData,
} from "../../../../redux/features/fieldForceTransaction";
import FieldForceTxnMultiCard from "../../../../components/FieldForceTransactionComp/FieldForceTxnMultiCard";

const getDefaultPageSize = () =>
  window.innerWidth >= GlobalConfiguration.innerWidthLargeSize
    ? PaginationConfiguration.paginationMid
    : window.innerWidth >= GlobalConfiguration.innerWidthMidSize
      ? PaginationConfiguration.paginationExtraSmall
      : PaginationConfiguration.paginationSmall;

const FieldForceTransactionMultiApproval = () => {
  const filterRef = useRef(null);
  const filterRefPagination = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [allAccounts, setAllAccounts] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectAllCard, setselectAllCard] = useState(false);
  const [label, setlabel] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [txnlabels, settxnLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [page, setPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [mainData, setMainData] = useState([]);
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || "",
  );
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || getDefaultPageSize(),
  );

  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.internalTxnCardHoverHeight,
  );

  const {
    FieldForceMultiMultiTxnWaitingApprovalError,
    FieldForceMultiTxnDeniedApprovalError,
  } = useSelector((state) => state?.fieldForceTransaction);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const conditionVarLengthOne = GlobalConfiguration.lengthCheckOne;
  const varLengthFifty = 50;
  // const conditionVarLengthFifty =
  //   mainData?.title?.current_page === mainData?.title?.total_pages
  //     ? mainData?.transactions?.length
  //     : 50;
  const conditionVarLengthFifty = mainData?.total_count
    ? Math.min(varLengthFifty, mainData.total_count)
    : varLengthFifty;
  const approvedOnCurrentPage = allAccounts.filter(
    (account) => account.field_force_account_approval_status === "approved",
  );
  const isAllCurrentPageSelected =
    approvedOnCurrentPage.length > GlobalConfiguration.lengthCheckZero &&
    approvedOnCurrentPage.every((itm) =>
      selectedTransactions.includes(itm.txn_id),
    );
  const isMultiSelectLimitReached =
    selectedTransactions?.length >= conditionVarLengthFifty ||
    isAllCurrentPageSelected;

  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const isTransactionPendingOutsideBankingHours =
    allAccounts?.some(
      (transaction) => transaction?.lifecycle_status === "pending",
    ) && isOutsideBankingHoursNow;

  const isAccountApprovalPendingOutsideBankingHours =
    allAccounts?.some(
      (transaction) =>
        transaction?.field_force_account_approval_status === "pending",
    ) && isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    isTransactionPendingOutsideBankingHours ||
    isAccountApprovalPendingOutsideBankingHours;

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const handlePagination = (pageNum) => {
    setDirection("");
    handleSubmit("pageno", pageNum);
    setPage(pageNum);
  };

  const openBeneTxnDetailModal = () => setShowTxnDetailPop(true);
  const closeBeneTxnDetailModal = () => setShowTxnDetailPop(false);
  const closeBeneAccountDetailModal = () => setisDrawerOpen(false);

  const SideDrawerOpen = async (id, _txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(true);
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      initCategoryFilter !== "" ||
        LabelSearchText?.length > GlobalConfiguration.lengthCheckZero,
    );
  };

  const handleClearParams = () => {
    setInitCategoryFilter("");
    setDisplayCategory("");
    setlabel([]);
    setLabelSearchText([]);
    setPage(GlobalConfiguration.lengthCheckOne);
    setSelectedTransactions([]);
    setSelectedSendTransactions([]);
    setTotalAmount(0);
    const keepPagesize = searchParam.get("pagesize") || dropdownOptionsList[0];
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${keepPagesize}`,
      },
      { replace: true },
    );
  };

  const fetchData = async () => {
    setLoadingData(true);
    let data = [];
    switch (active) {
      case "Category": {
        const response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data =
          response?.payload?.categories?.map((itm) => ({
            id: String(itm?.id),
            Category: itm.name,
            display: itm.name,
            Description: itm?.description || "Not given",
          })) ?? [];
        break;
      }
      case "Labels":
        data =
          txnlabels
            ?.filter((itm) =>
              itm.toLowerCase().includes(searchUserTextDebounce.toLowerCase()),
            )
            ?.map((val) => ({ id: val, Label: val })) ?? [];
        break;
      default:
        break;
    }
    setInputData(data);
    setLoadingData(false);
  };

  const fetchTransactions = async () => {
    setAllBeneTxnAccountsLoading(true);
    try {
      const queryParams = {
        page_no: page,
        page_size: pageSize,
        lifecycle_status: "pending",
      };
      if (LabelSearchText?.length > GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (initCategoryFilter !== "") {
        queryParams.category_id = initCategoryFilter;
      }

      const response = await dispatch(fieldForceTxnActionable(queryParams));
      const newData = response?.payload?.transactions || [];
      const formattedData = newData.map((account) => ({
        ...account,
        loading: false,
        error: "false",
        message: "",
        last_updated_user_id_check: "false",
        distribution_lifecycle_status: "",
      }));

      setTotalCount(
        response?.payload?.total_count ?? GlobalConfiguration.lengthCheckZero,
      );
      setMainData(response?.payload ?? {});
      setAllAccounts(formattedData);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      setMainData([]);
      setAllAccounts([]);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const handleSelectAll = () => {
    const maxLimit = conditionVarLengthFifty;

    const approvedOnPage = allAccounts.filter(
      (account) => account.field_force_account_approval_status === "approved",
    );

    if (!selectedTransactions?.length) {
      const toSelect = approvedOnPage.slice(
        GlobalConfiguration.lengthCheckZero,
        maxLimit,
      );
      setSelectedTransactions(toSelect.map((itm) => itm.txn_id));
      setSelectedSendTransactions(toSelect);
      setTotalAmount(
        toSelect.reduce((sum, item) => sum + Number(item.amount), 0),
      );
    } else if (selectedTransactions?.length === maxLimit && !isFilterApplied) {
      setSelectedTransactions([]);
      setSelectedSendTransactions([]);
      setTotalAmount(GlobalConfiguration.lengthCheckZero);
    } else if (
      approvedOnPage?.length > GlobalConfiguration.lengthCheckZero &&
      approvedOnPage?.every((ac) => selectedTransactions?.includes(ac.txn_id))
    ) {
      let arr = [...selectedTransactions];
      for (
        let i = GlobalConfiguration.lengthCheckZero;
        i < approvedOnPage?.length;
        i++
      ) {
        if (selectedTransactions?.includes(approvedOnPage[i].txn_id)) {
          arr = arr.filter((id) => {
            return id !== approvedOnPage[i].txn_id;
          });
        }
      }
      setSelectedTransactions(arr);

      const txnArr = selectedSendTransactions.filter((itm) =>
        arr.includes(itm.txn_id),
      );
      setSelectedSendTransactions(txnArr);
      setTotalAmount(
        txnArr.reduce((sum, item) => sum + Number(item.amount), 0),
      );
    } else {
      let arr = [...selectedTransactions];
      let txnArr = [...selectedSendTransactions];

      for (let i = GlobalConfiguration.lengthCheckZero; i < maxLimit; i++) {
        if (arr?.length < maxLimit) {
          if (!selectedTransactions?.includes(approvedOnPage[i]?.txn_id)) {
            if (approvedOnPage[i]?.txn_id) {
              arr.push(approvedOnPage[i]?.txn_id);
              txnArr.push(approvedOnPage[i]);
            }
          }
        }
      }

      setSelectedTransactions(arr);
      setSelectedSendTransactions(txnArr);
      setTotalAmount(
        txnArr.reduce((sum, item) => sum + Number(item.amount), 0),
      );
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  useEffect(() => {
    dispatch(enableSwitcher());
    const availableLabels = sessionStorage?.getItem("AvailableLabelsTxnFF");
    if (availableLabels) {
      try {
        settxnLabels(JSON.parse(availableLabels) || []);
      } catch (e) {
        settxnLabels([]);
      }
    }
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    const currentPageApproved = allAccounts.filter(
      (account) => account.field_force_account_approval_status === "approved",
    );

    if (currentPageApproved.length > 0) {
      const isAllCurrentSelected = currentPageApproved.every((itm) =>
        selectedTransactions.includes(itm.txn_id),
      );
      const isMaxLimitReached =
        selectedTransactions.length === conditionVarLengthFifty;
      setselectAllCard(isAllCurrentSelected || isMaxLimitReached);
    } else {
      setselectAllCard(false);
    }
  }, [selectedTransactions, allAccounts, conditionVarLengthFifty]);

  useEffect(() => {
    dispatch(resetFieldForceMultiApprovalError());
    dispatch(resetFieldForceMultiDeniedApprovalData());
  }, [
    FieldForceMultiMultiTxnWaitingApprovalError,
    FieldForceMultiTxnDeniedApprovalError,
    dispatch,
  ]);

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, initCategoryFilter, LabelSearchText, markerData]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero)
        return GlobalConfiguration.lengthCheckOne;
      if (prevPage > newTotalPages) return newTotalPages;
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    const handlefilter = (e) => {
      if (
        (filterRef.current && filterRef.current.contains(e.target)) ||
        (filterRefPagination.current &&
          filterRefPagination.current.contains(e.target))
      ) {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handlefilter);
    return () => document.removeEventListener("click", handlefilter);
  }, [filterRef, filterRefPagination]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [initCategoryFilter, LabelSearchText]);

  return (
    <>
      {/* Find this condition block inside FieldForceTxnMultiApproval.jsx */}
      {showTxnDetailPop && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={closeBeneTxnDetailModal}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <FieldForceTxnDetailsPopup
              closePopup={closeBeneTxnDetailModal}
              account_txn_id={txnId}
              type="bene_txn_detail_modal"
              TransactionHeader="Field force transaction details"
              setParentTxnList={(updater) => {
                setAllAccounts((prevAccounts) => {
                  const updatedAccounts =
                    typeof updater === "function"
                      ? updater(prevAccounts)
                      : prevAccounts;

                  return updatedAccounts.filter(
                    (txn) => String(txn.txn_id) !== String(txnId),
                  );
                });

                setSelectedTransactions((prevIds) =>
                  prevIds.filter((id) => String(id) !== String(txnId)),
                );

                setSelectedSendTransactions((prevTxns) => {
                  const updatedTxns = prevTxns.filter(
                    (t) => String(t.txn_id) !== String(txnId),
                  );

                  setTotalAmount(
                    updatedTxns.reduce(
                      (sum, item) => sum + Number(item.amount),
                      0,
                    ),
                  );
                  return updatedTxns;
                });
              }}
            />
          </div>
        </div>
      )}
      {isDrawerOpen && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={closeBeneAccountDetailModal}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <FieldForceAccountDetailsPopup
              field_force_account_id={BeneTxnDetailsId}
              closeBeneAccountDetailModal={closeBeneAccountDetailModal}
              setAllAccounts={setAllAccounts}
            />
          </div>
        </div>
      )}

      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}

      <div
        className="bg-primary-bg flex flex-col h-screen relative overflow-hidden"
        style={{
          background: showInnerSearchBar ? "var(--PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative flex flex-col overflow-hidden">
            <div
              className={`w-width-full h-navbar-breadcrumb-height Qmd:block hidden ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} flex-shrink-0`}
            ></div>

            <div className="z-z-index-overlay">
              <ApprovalTopNavComponent
                direction={direction}
                ispagination={shouldShowPagination}
                handleBack={() => navigate(GlobalConfiguration?.navigate_back)}
                isSelectionView={true}
                topNavHeader={totalAmount}
                topNavSubText="Total amount"
                selectionText={`Transactions selected : ${selectedTransactions?.length}`}
                selectionBtnProps={
                  !shouldShowPagination
                    ? undefined
                    : {
                        btnText: `Select up to ${varLengthFifty}`,
                        btnType: "button",
                        enabledBgColor: isMultiSelectLimitReached
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)",
                        hoverOption: isMultiSelectLimitReached
                          ? "black"
                          : "white",
                        enabledTextColor: "var(--text-primary)",
                        icon: isMultiSelectLimitReached
                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                        handleFunction: handleSelectAll,
                      }
                }
                topNavCtaBtn2Props={{
                  btnText: "Proceed",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  inActiveVariantNeeded: true,
                  handleFunction: () => {
                    if (selectedTransactions?.length >= conditionVarLengthOne) {
                      const selectedData = {
                        selectedSendTransactions,
                        selectedTransactions,
                        timestamp: Date.now(),
                      };
                      sessionStorage.setItem(
                        "selectedFieldForceTxnData",
                        JSON.stringify(selectedData),
                      );
                      navigate(
                        "/field_force_transaction_dashboard/field_force_transaction_multi_approval/multi_approval",
                      );
                    }
                  },
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedTransactions?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/field_force_transaction_dashboard/field_force_transaction_single_approval",
                    ),
                }}
                iconComponentArray={[
                  {
                    icon: ICONS?.SEARCH_WHITE,
                    title: "Search",
                    hoverOption: "white",
                    isLoading: false,
                    isDisabled: allBeneTxnAccountsLoading,
                    enabledBgColor: initCategoryFilter
                      ? "var(--text-primary)"
                      : "var(--primary-bg)",
                    handleFunction: () => setShowSearchBar((prev) => !prev),
                  },
                ]}
                filteredSearchProps={{
                  setShowInnerSearchBar,
                  showSearchBar,
                  isSearchDisabled: allBeneTxnAccountsLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search field force transaction",
                  filterPlaceholder: "transaction context",
                  filterItems: [
                    {
                      name: "Category",
                      valueType: "string",
                      short_name: "Cat",
                      isMulti: false,
                      value: initCategoryFilter,
                      setValue: (val) => {
                        setPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit("category", val);
                        setInitCategoryFilter(val);
                        if (!val) {
                          setDisplayCategory("");
                          handleSubmit("dispCat", "");
                        }
                      },
                      setDisplayValue: (val) => {
                        setDisplayCategory(val || "");
                        handleSubmit("dispCat", val || "");
                      },
                      isDropdown: true,
                      isDisabled: allBeneTxnAccountsLoading,
                      displayValue: displayCategory,
                    },
                    {
                      name: "Labels",
                      valueType: "string",
                      short_name: "Lab",
                      isMulti: true,
                      value: label,
                      setValue: (val) => {
                        setPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit(
                          "label",
                          Array.isArray(val) ? val.join(",") : val,
                        );
                        setlabel(val);
                        setLabelSearchText(val);
                      },
                      isDropdown: true,
                      isDisabled: allBeneTxnAccountsLoading,
                    },
                  ],
                  isSearchClearAllDisabled: !(
                    initCategoryFilter?.length || LabelSearchText?.length
                  ),
                  inputData,
                  active,
                  setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: false,
                }}
              />
            </div>

            <div
              className={`h-height-full flex flex-col overflow-hidden bg-primary-bg ${
                allAccounts?.length === GlobalConfiguration.lengthCheckZero ||
                allBeneTxnAccountsLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}

              <div
                ref={filterRef}
                className="w-width-full overflow-y-auto h-[-webkit-fill-available]"
                style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
                onScroll={handleScroll}
              >
                {allBeneTxnAccountsLoading ? (
                  <div className="loader-container m-auto justify-center items-center flex h-height-full">
                    <Loader />
                  </div>
                ) : !allAccounts?.length ? (
                  <div className="int-txn-mutli-no-account-found">
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          isFilterApplied
                            ? ICONS?.NO_DATA_FOUND
                            : ICONS?.NO_PENDING_TRANSACTION
                        }
                        alt={
                          isFilterApplied ? "FiterNoAccount" : "NoAccountFound"
                        }
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account">
                      {isFilterApplied ? (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more transactions that require <br />{" "}
                            your approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Field force transaction dashboard"
                              handleFunction={() =>
                                navigate("/field_force_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${
                      showInnerSearchBar
                        ? "pointer-events-none"
                        : "flex flex-col flex-1 items-center justify-center mx-auto"
                    }`}
                    style={{
                      scrollPaddingTop: "var(--padding-md)",
                      scrollPaddingBottom: "var(--padding-md)",
                    }}
                  >
                    {shouldShowBankingHoursAlert && (
                      <div className="max-w-tab-width-normal w-full Qlg:mx-auto pt-padding-md px-padding-md Qlg:px-padding-base">
                        <CommonAlertCard
                          title="Functioning outside banking hours"
                          texts="Transactions will be processed automatically during the next bank working day. Learn more"
                          highlightedText="Learn more"
                          onHighlightedTextClick={() =>
                            setShowBankingHoursPopup(true)
                          }
                        />
                      </div>
                    )}
                    <FieldForceTxnMultiCard
                      filterRef={filterRef}
                      filterOpen={showInnerSearchBar}
                      data={allAccounts}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      SideDrawerOpen={SideDrawerOpen}
                      openBeneTxnDetailModal={openBeneTxnDetailModal}
                      setTxnId={setTxnId}
                      maxSelectionLimit={conditionVarLengthFifty}
                    />
                  </div>
                )}
              </div>
            </div>

            <div
              className={`flex flex-col absolute bottom-bottom-base ${
                showInnerSearchBar
                  ? "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none"
                  : "opacity-base-opacity"
              }`}
            >
              {shouldShowPagination && (
                <div
                  ref={filterRefPagination}
                  className="z-z-index-fixed-ui w-screen"
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptionsList}
                    handlePagination={handlePagination}
                    currentPage={page}
                    setIsOpen={setIsOpen}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceTransactionMultiApproval;
